import { SharedPathSegments } from './shared-path-segments';

export class SharedRoutes {
  static auth(): string {
    return `/${SharedPathSegments.auth()}`;
  }
  static resetPassword(): string {
    return `/${SharedPathSegments.auth()}/${SharedPathSegments.resetPassword()}`;
  }
}
